export default {"src":"/_next/static/media/salesforce-oauth.97deb1f4.svg","height":41,"width":40};